import React from "react";
import { ListOrdered, Trash2, Plus } from "lucide-react";

/** "Jak to funguje" editor — title/subtitle + fully editable ordered steps. */
export default function HowItWorksEditor({ data, onChange }) {
  const val = data || { title: "", subtitle: "", steps: [] };
  const steps = Array.isArray(val.steps) ? val.steps : [];
  const setField = (key, value) => onChange({ ...val, [key]: value });
  const setStepAt = (i, patch) => onChange({ ...val, steps: steps.map((s, idx) => (idx === i ? { ...s, ...patch } : s)) });
  const removeStep = (i) => onChange({ ...val, steps: steps.filter((_, idx) => idx !== i) });
  const addStep = () => onChange({ ...val, steps: [...steps, { title: "", text: "" }] });

  return (
    <div className="rounded-2xl bg-apex-card border border-apex-line p-5" data-testid="section-how-it-works">
      <div className="text-xs uppercase tracking-[0.3em] text-apex-gold/80 mb-1 flex items-center gap-2">
        <ListOrdered className="w-3.5 h-3.5" /> Jak to funguje
      </div>
      <p className="text-xs text-apex-cream/60 mb-4">Upravte nadpis, podtitulek a jednotlivé kroky procesu rezervace.</p>
      <div className="space-y-3 mb-4">
        <label className="block">
          <div className="text-xs text-apex-cream/70 mb-1">Nadpis sekce</div>
          <input
            type="text"
            value={val.title || ""}
            onChange={(e) => setField("title", e.target.value)}
            className="w-full px-3 py-2 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm focus:outline-none focus:border-apex-gold/60"
            data-testid="how-input-title"
          />
        </label>
        <label className="block">
          <div className="text-xs text-apex-cream/70 mb-1">Podtitulek</div>
          <input
            type="text"
            value={val.subtitle || ""}
            onChange={(e) => setField("subtitle", e.target.value)}
            className="w-full px-3 py-2 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm focus:outline-none focus:border-apex-gold/60"
            data-testid="how-input-subtitle"
          />
        </label>
      </div>
      <div className="text-xs text-apex-cream/70 mb-2">Kroky</div>
      <div className="space-y-3">
        {steps.map((s, i) => (
          <div key={i} className="rounded-xl border border-apex-line bg-apex-bg/50 p-4 space-y-2">
            <div className="flex items-start gap-2">
              <span className="text-apex-gold text-xs font-bold mt-2.5">{i + 1}.</span>
              <input
                type="text"
                value={s.title}
                onChange={(e) => setStepAt(i, { title: e.target.value })}
                placeholder="Titulek kroku"
                className="flex-1 px-3 py-2 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm font-semibold focus:outline-none focus:border-apex-gold/60"
                data-testid={`how-step-${i}-title`}
              />
              <button
                type="button"
                onClick={() => removeStep(i)}
                className="px-2 py-2 rounded-lg border border-red-500/40 text-red-300 text-xs hover:bg-red-500/10"
                data-testid={`how-step-${i}-remove`}
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
            <textarea
              value={s.text}
              rows={2}
              onChange={(e) => setStepAt(i, { text: e.target.value })}
              placeholder="Popis kroku"
              className="w-full px-3 py-2 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm resize-y focus:outline-none focus:border-apex-gold/60"
              data-testid={`how-step-${i}-text`}
            />
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={addStep}
        className="mt-3 text-xs px-3 py-1.5 rounded-lg border border-apex-gold/40 text-apex-gold hover:bg-apex-gold/10 inline-flex items-center gap-1.5"
        data-testid="how-step-add"
      >
        <Plus className="w-3.5 h-3.5" /> Přidat krok
      </button>
    </div>
  );
}
